import React from 'react';

export default function BetaLabel() {
  return <div className="beta-label text-white pl-1 position-fixed">BETA</div>;
}
